// Added as a simple, low weight lookup for getting display names for the connection types.
// The data is also in the connection types table but it seemed a bit much to either call it and get the data...
// Or weave it into the response for each connection. If you want to use another method, let me know.

// Store the supported connection type display names
const connectionTypeDisplayNames = {
    AMAZON: "Amazon",
    EBAY: "eBay",
    ONBUY: "OnBuy",
    STRICH: "Strich Hosted Store",
    VIRTUEMART: "Virtuemart"
};



// This function gets the display name for a connection type
export const GetConnectionTypeDisplayName = (connectionType) => {

    // Return nothing when no connection type is supplied
    if (!connectionType) { return ""; }

    // Convert the connection type into the standard lookup format
    const connectionTypeKey = String(connectionType).toUpperCase();

    // Return the display name from the lookup
    return connectionTypeDisplayNames[connectionTypeKey] || "";

};